import type { IamScopeType } from '../../../services/iam';

// Scope-level colour tokens shared by ScopeTag and GrantChip. Split out of
// ScopeTag.tsx because mixing component and plain-value exports breaks fast refresh.

const SCOPE_METER_LEVEL: Record<IamScopeType, number> = {
    platform: 3,
    practice: 2,
    patient: 1
};

const SCOPE_WRAP_CLASS: Record<IamScopeType, string> = {
    platform: 'bg-indigo-900 border border-indigo-900 text-white',
    practice: 'bg-blue-50 border border-blue-100 text-blue-700',
    patient: 'bg-white border border-gray-300 text-gray-600'
};

// 'dark' bars sit on the solid platform chip (white bars on indigo); 'light'
// bars sit on the two paler chips (currentColor bars, dimmed when unlit).
const METER_TONE: Record<IamScopeType, 'dark' | 'light'> = {
    platform: 'dark',
    practice: 'light',
    patient: 'light'
};

export function scopeMeterLevel(type: IamScopeType): number {
    return SCOPE_METER_LEVEL[type];
}

export function scopeWrapClass(type: IamScopeType): string {
    return SCOPE_WRAP_CLASS[type];
}

export function scopeMeterTone(type: IamScopeType): 'dark' | 'light' {
    return METER_TONE[type];
}
